import { render, staticRenderFns } from "./addRedZone.vue?vue&type=template&id=24258066&"
import script from "./addRedZone.vue?vue&type=script&lang=js&"
export * from "./addRedZone.vue?vue&type=script&lang=js&"
import style0 from "./addRedZone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports